module.exports = __webpack_public_path__ + "static/media/Le-Duc-Trong.55a320f9.png";